import { formatDeviceType, formatOsLabel } from './usuariosOnline.constants';

/**
 * Celda compartida: tipo de dispositivo + SO + IP.
 */
export const DeviceInfoCell = ({
    deviceType,
    os,
    ip,
    className = '',
}) => {
    const typeLabel = formatDeviceType(deviceType);
    const osLabel = formatOsLabel(os);
    const ipLabel = ip || '—';

    return (
        <div className={`flex min-w-0 flex-col gap-0.5 ${className}`.trim()}>
            <span className='text-sm font-medium text-slate-800'>{typeLabel}</span>
            <span className='text-xs text-slate-500'>{osLabel}</span>
            <span className='font-mono text-xs tabular-nums text-slate-600'>{ipLabel}</span>
        </div>
    );
};

export const LiveDeviceInfoCell = ({ sessions = [] }) => {
    if (!sessions.length) {
        return <span className='text-sm text-slate-400'>—</span>;
    }

    return (
        <div className='flex flex-col gap-2'>
            {sessions.map((session, index) => (
                <DeviceInfoCell
                    key={`${session.deviceType}-${session.os}-${session.ip}-${index}`}
                    deviceType={session.deviceType}
                    os={session.os}
                    ip={session.ip}
                />
            ))}
        </div>
    );
};
